module.exports = __webpack_public_path__ + "static/media/hashtag-nft-6.084a58f8.jpg";